import { defineRecipe } from '@chakra-ui/react/styled-system';

const separatorRecipe = defineRecipe({
  className: 'separator',
  base: {
    display: 'block',
    borderColor: 'border/regular',
    borderStyle: 'solid',
  },
  variants: {
    variant: {},
    orientation: {
      horizontal: {
        borderTopWidth: 'var(--separator-thickness)',
        width: '100%',
      },
      vertical: {
        borderInlineStartWidth: 'var(--separator-thickness)',
        minHeight: '20',
      },
    },
    size: {
      '1': {
        '--separator-thickness': '1px',
      },
      '2': {
        '--separator-thickness': '2px',
      },
    },
  },
  defaultVariants: {
    size: '1',
    orientation: 'horizontal',
  },
});

export default separatorRecipe;
